import CryptoJS from 'crypto-js'
/**
 * @word 要加密的内容
 * @keyWord String  服务器随机返回的关键字
 *  */
export function aesEncrypt(word, keyWord = 'XwKsGlMcdPMEhR1B') {
    var key = CryptoJS.enc.Utf8.parse(keyWord)
    var srcs = CryptoJS.enc.Utf8.parse(word)
    var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
    return encrypted.toString()
}
/**
 * 
 * @param {*} timestamp 时间戳
 */
export function md5Encrypt(timestamp, uuid) {
    var URI = "/api/app/auth_1" //固定写成这个地址即可
    var Timestamp = timestamp //第一个接口返回的时间戳
    var rand = uuid //js生成的 uuid
    var uid = 0 //定写成0即可
    var PrivateKey = "aliyuncdnexp2024"
    var str = `${URI}-${Timestamp}-${rand}-${uid}-${PrivateKey}`
    var encrypted = CryptoJS.MD5(str).toString()
    return encrypted
}


// WEBPACK FOOTER //
// ./src/components/verifition/utils/ase.js